angular.module('core')
  .directive('mobileInfiniteScroll', ['$rootScope', function ($rootScope) {
    return {
      restrict: 'A',
      link: function($scope, $element) {
        var $rightPane = $('right-pane');
        var offset = 15;

        /* On mobile we enable native scrolling so this will only fire on mobile
         * otherwise we use perfect-scrollbar's behavior for infinite scroll
         */
        $element.bind('scroll', function() {
          // @TODO: need to normalize heights so we can not use a buffer
          var height = $rightPane.offset().top + $rightPane.outerHeight() + offset;
          var buffer = 100;

          if( height - buffer <= $element.outerHeight() ) {
            $rootScope.$broadcast('mobileScrollBottom');

          }

        });
      }
    };
  }]);
